/*  ==========================================================================
    TAB PANELS
    Helper to make a single content area with multiple panels.

    INFO:
    - you can add also your own tab panels if existing ones don't work for
      your requirements!
    - each tab panel must have following css classes and should be
      structured (roughly) like this:

    <div class="bn-tab-panel">
        <div class="bn-tab-panel__tabs">
            <button class="bn-tab-panel__tab" data-panel="1">
                Tab 1
            </button>
            <button class="bn-tab-panel__tab" data-panel="2">
                Tab 2
            </button>
        </div>
        <div class="bn-tab-panel__panels">
            <div class="bn-tab-panel__panel bn-tab-panel__panel-1">
                Panel 1
            </div>
            <div class="bn-tab-panel__panel bn-tab-panel__panel-2">
                Panel 2
            </div>
        </div>
    </div>
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';

/*
 * SIMPLE TAB PANEL
 */

// tab panel without slide animation
export function initSimpleTabPanel($element) {
    if ($element.hasClass('bn-tab-panel')) {

        // set first panel active
        $element.find('.bn-tab-panel__tabs .bn-tab-panel__tab').first().addClass('bn-tab-panel__tab--act');
        $element.find('.bn-tab-panel__panels .bn-tab-panel__panel').first().addClass('bn-tab-panel__panel--act');

        // open panel on click
        $element.find('.bn-tab-panel__tabs').on('click', '.bn-tab-panel__tab', function () {
            let $this = $(this),
                target = $(this).attr('data-panel');
            if (!$this.hasClass('bn-tab-panel__tab--act')) {
                $this.parents('.bn-tab-panel').find('.bn-tab-panel__tabs .bn-tab-panel__tab.bn-tab-panel__tab--act').removeClass('bn-tab-panel__tab--act');
                $this.parents('.bn-tab-panel').find('.bn-tab-panel__panels .bn-tab-panel__panel.bn-tab-panel__panel--act').removeClass('bn-tab-panel__panel--act');
                $this.addClass('bn-tab-panel__tab--act');
                $this.parents('.bn-tab-panel').find('.bn-tab-panel__panels .bn-tab-panel__panel.bn-tab-panel__panel-'+target).addClass('bn-tab-panel__panel--act');
            }
        });

    }
}



// WEBPACK FOOTER //
// ./source/js/utilities/lib/tab-panels.js